import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { LoginAfterCheckLogin } from "../../components/common/Common";

import menu01Icon from "../../img/icon/icon-setting-menu01.svg";
import menu02Icon from "../../img/icon/icon-setting-menu02.svg";
import menu03Icon from "../../img/icon/icon-setting-menu03.svg";

import "../../css/style.css";

//비밀번호 찾기
const Setting = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content setting-wrap">
      <HeaderBranchTitle varPageTitle={'설정'} varBackString="none"/>
      <div className="vh-content-body">
        <div className="setting-con">
          <div className="center-wrap">
            <div className="con con01">					
              <ul>
                <li><Link to="/Branch/SemesterSet"><img src={menu01Icon} alt=""/>학기 설정</Link></li>
                <li><Link to="/Branch/SetClassroom"><img src={menu02Icon} alt=""/>교실 설정</Link></li>
                <li><Link to="/Branch/ClassSet"><img src={menu03Icon} alt=""/>클래스 설정</Link></li>
              </ul>
            </div>					
          </div>
        </div>
      </div>
    </div>	
  );
}
export default Setting;